import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WioaProgram } from '../models/wioaProgram';
/*import { ModuleComponent } from '../../employment101/guide/components/module.component';*/
import { TrainingProvider } from '../models/trainingProvider';

@Injectable()
export class TrainingService{

  private _trainingUrl = './api/training/';

  constructor(private _http: HttpClient) {

  }


  getTrainingOrWioaProviders(): Observable<Array<any>> {
    return this._http.get<Array<any>>(this._trainingUrl + 'trainingOrWioaProviders')
      .pipe(
        map(result => result),
        catchError(this.handleError)
      );
  }

  getTraingProviders(): Observable<Array<TrainingProvider>> {
    return this._http.get<Array<TrainingProvider>>(this._trainingUrl + 'trainingProviders')
      .pipe(
        map(result => result),
        catchError(this.handleError)
      );

  }

  updateTrainingProvider(provider: TrainingProvider) {
    return this._http.put(this._trainingUrl + 'trainingProviders', provider)
      .pipe(
        map((resp: Response) => resp),
        catchError(this.handleError)
      );
  }

  removeTrainingProvider(id: number) {

    return this._http.delete(this._trainingUrl + 'trainingProviders?id=' + id).pipe(
      map((resp: Response) => resp),
      catchError(this.handleError)
    );
  }

  getWioaPrograms(): Observable<Array<WioaProgram>> {

    return this._http.get<Array<WioaProgram>>(this._trainingUrl + 'wioaPrograms')
      .pipe(
        map(result => result),
        catchError(this.handleError)
      );

  }

  updateWioaProgram(wioaProgram: WioaProgram) {
    return this._http.put(this._trainingUrl + 'wioaPrograms', wioaProgram)
      .pipe(
        map((resp: Response) => resp),
        catchError(this.handleError)
      );
  }

  removeWioaProgram(id: number) {
    return this._http.delete(this._trainingUrl + 'wioaPrograms?id=' + id).pipe(
      map((resp: Response) => resp),
      catchError(this.handleError)
    );
  }

  private handleError(err: HttpErrorResponse) {
    console.log(err.message);
    return Observable.throw(err.message);
  }
}
